import { render, staticRenderFns } from "./addVehicleType.vue?vue&type=template&id=06435032"
import script from "./addVehicleType.vue?vue&type=script&lang=js"
export * from "./addVehicleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports